<div class="ir-area ir-mask th-mask" [open]="!isOpen" [attr.data-keyboard]="true" [attr.data-backdrop]="false">
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ title }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2 class="th-txt" [ngClass]="{ 'ir-position--m ir-txt--big modal': center }">
          <div class="ir-modal-loaded-icon" *ngIf="warningIcon">
            <i class="material-icons warning">offline_pin</i>
          </div>
          <span innerHtml="{{ message }}"></span>
        </h2>
      </div>
      <div #child></div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6" *ngIf="closeButton">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="close()">
            <span>{{ cancelButtonText }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6" (click)="submit()">
          <button
            class="ir-btn ir-btn--big ir-btn--block ir-txt--right"
            [ngClass]="danger ? 'th-btn-remove' : 'th-btn-modal--action'"
          >
            <span>{{ okButtonText }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
